// @flow

import * as React from "react";
import { useSelector } from "react-redux";

import actions from "../actions/index.js";
import usePageFromStore from "../hooks/usePageFromStore";
import Config from "../constants/Config";
import addACFData from "../utils/addACFData";
import getContentReferenceTileProps from "../utils/getContentReferenceTileProps";

import HeroHome from "../components/organisms/HeroHome";
import SocialMediaFeed from "../components/organisms/SocialMediaFeed";
import TileSlider from "../components/organisms/TileSlider";
import Leaderboard from "../components/organisms/Leaderboard.js";

const Home = (): React.Node => {
    const { page } = usePageFromStore();
    const { loggedIn, profile } = useSelector((state: any): any => state.user);

    // Hero Content
    const hero = page.acf.hero;

    // Curated Content
    const curatedContent = page.acf.curated_content;

    // Events Content
    const events = useSelector((state: any): any => state.events.events);

    //Leaderboard
    const leaderboard = page.acf.bottom_leaderboard_ad
        ? getContentReferenceTileProps(
              addACFData(page.acf.bottom_leaderboard_ad)
          )
        : null;

    return (
        <>
            {/* Hero */}
            <HeroHome {...hero} />

            {/* Curated Content - content slider component */}
            <TileSlider
                {...curatedContent}
                useContainer={true}
                colClass="col-xs-12"
                ctaClass="home-explore-cta"
                title={
                    loggedIn
                        ? `${
                              profile.preferred_name || profile.first_name
                          }, explore ActivateUTS`
                        : "Explore ActivateUTS"
                }
            />

            {curatedContent && events ? (
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <hr />
                        </div>
                    </div>
                </div>
            ) : null}

            {/* Events - content slider component */}
            <TileSlider
                useContainer={true}
                colClass="col-xs-12"
                title="What's on"
                tiles={events}
                cta={{
                    url: Config.routes.events,
                    title: "All events",
                }}
            />

            {/* Leaderboard */}
            {leaderboard && (
                <Leaderboard
                    useContainer={true}
                    imageDesktop={leaderboard.image_desktop}
                    imageMobile={leaderboard.image_mobile}
                    alt={leaderboard.title}
                    link={leaderboard.url}
                    pageType="home"
                    position="bottom"
                />
            )}

            {/* Social Media Feed */}
            <SocialMediaFeed type="homepage" title="Follow ActivateUTS" />
        </>
    );
};

Home.preload = ({ passed: { store }, location }: any): Promise<any> => {
    return Promise.all([store.dispatch(actions.fetchEvents())]);
};

export default Home;
